import React from 'react'
import styles from './ProductСard.module.scss'



const ProductСardMin = ({item}) => {

        return (
            <li
                className={styles.item} 
                >                    
                <div className={styles.link}>
                    <div className={styles.cell_box}>
                        <img className={styles.cell_image} src={item.image} alt={item.alt}/>
                    </div>
                    <div className={styles.cell_info}>
                        <p className={styles.cell_subtitle}>{item.volume}</p>
                        <div className={styles.cell_box_button}>
                            <p className={styles.cell_number}>цена по запросу</p>
                        </div>
                        
                    </div>
                </div>    
            </li>                                          
        )
    }
    
    export default ProductСardMin